import script from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=7163c462&lang=scss&scoped=true"
import "./BaseModal.vue?vue&type=style&index=1&id=7163c462&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7163c462"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBar,QSpace});qInstall(script, 'directives', {ClosePopup});
